import React, { useState, useEffect } from 'react';
import InputList from './InputList';

const IL_OtherItems = ({
  questionnaireCriteria,
  onCriteriaChange,
  label = "Other Items",
  placeholder = "Enter other item...",
  emptyMessage = "No other items added yet"
}) => {

  // Extract other items from questionnaire criteria
  const getInitialOtherItems = () => {
    if (questionnaireCriteria?.otherItems?.items) {
      return questionnaireCriteria.otherItems.items.map(item => ({
        title: item.item,
        subtitle: item.rationale || ''
      }));
    }
    return [];
  };

  // State for other items
  const [otherItems, setOtherItems] = useState(getInitialOtherItems());

  // Update other items when questionnaireCriteria changes
  useEffect(() => {
    setOtherItems(getInitialOtherItems());
  }, [questionnaireCriteria]);

  // Update other items criteria JSON
  const updateOtherItemsCriteria = (newOtherItems) => {
    if (!questionnaireCriteria) return;

    // Create updated criteria with new other items
    const updatedCriteria = {
      ...questionnaireCriteria,
      otherItems: {
        ...questionnaireCriteria.otherItems,
        items: newOtherItems.map(itemObj => {
          // Check if this item already exists in our current criteria
          const existingItem = questionnaireCriteria.otherItems?.items?.find(
            existingItem => existingItem.item === itemObj.title
          );
          
          if (existingItem) {
            // Keep existing item with all its properties
            return existingItem;
          } else {
            // Create new item entry with otherItems specific structure
            return {
              item: itemObj.title,
              rationale: itemObj.subtitle || "",
              context: []
            };
          }
        })
      }
    };

    // Call parent callback with only the updated criteria
    onCriteriaChange(updatedCriteria);
  };

  // Handle other items change
  const handleOtherItemsChange = (newOtherItems) => {
    setOtherItems(newOtherItems);
    updateOtherItemsCriteria(newOtherItems);
  };

  return (
    <InputList
      items={otherItems}
      onItemsChange={handleOtherItemsChange}
      label={label}
      placeholder={placeholder}
      emptyMessage={emptyMessage}
    />
  );
};

export default IL_OtherItems;
